import request from '../../utils/request';

export function getSustainabilityData(params: { startRange: string; endRange: string; companyId: number }) {
  return request(`/sustainability`, {
    method: 'GET',
    params,
  });
}
